import useApi from './useApi';

const useIdentityService = () => {
  const api = useApi();

  const getIdentity = async () => await api.get(`/user/identity`);

  const isUserAuthenticated = () => !!api.accessToken;

  const loggedOut = async () => await api.post('/user/loggedout');

  return {
    getIdentity,
    isUserAuthenticated,
    loggedOut,
  };
};

export default useIdentityService;
